module.exports = __webpack_public_path__ + "static/media/logo.160c3a32.png";